<template>
  <div id="app">    
    <transition :name="transitionName">
      <router-view class="Router"/>    
    </transition>
    
  </div>
</template>

<script>
export default {
  data(){
    return{
       active: 0,
       tabbarShow:true,
        arrTab:['/index','/farm','/agronomy','/my'],
        transitionName:'slide-right'
    }
  },
  watch: {
      $route(to, from) {
        // 切换动画
        let isBack = this.$router.isBack // 监听路由变化时的状态为前进还是后退
        if (isBack) {
          this.transitionName = 'slide-left'
        } else {
          this.transitionName = 'slide-right'
        }
        this.$router.isBack = false
      }
    },
 mounted(){
    // 安卓后退键
    this.mui.plusReady( () =>{
      var backcount = 0;
      this.mui.back = ()=> {
        let path = this.$route.path;
        console.log("path:"+path);
 
        if (this.arrTab.includes(path)) {
          // 主导航页
          if (this.mui.os.ios) return;
          if (backcount > 0) {
            if (window.plus) plus.runtime.quit();
            return;
          };
          this.$toast('再点击一次退出应用!')
          backcount++;
          setTimeout( () =>{
            backcount = 0;
          }, 2000);
        } else {
          // 子页面
          console.log('子页面后退键');
          this.$router.go(-1);
        }
      };
    })
  },
  methods: {    
    
  },
}
</script>

<style>
/* http://meyerweb.com/eric/tools/css/reset/ 
   v2.0 | 20110126
   License: none (public domain)
*/

html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
	font: inherit;
	vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure, 
footer, header, hgroup, menu, nav, section {
	display: block;
}
body {
	line-height: 1;
}
ol, ul {
	list-style: none;
}
blockquote, q {
	quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
	content: '';
	content: none;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; 
  color: #2c3e50;
 background:#f8f8f8 
}

.van-nav-bar{width:100%;position: fixed!important;background:#0076bf!important;z-index:99!important}
.van-nav-bar__title,.van-nav-bar .van-icon,.van-nav-bar__text{color:#fff!important}
.van-nav-bar__text:active{background:#0076bf!important}
body,html,#app{height:100%;background:#efeff4}
.pt46{padding-top:46px}



.slide-left-enter,.slide-right-leave-active {
      opacity: 0;
      transform: translate3d(-100%, 0, 0);
    }
    .slide-left-leave-active,
    .slide-right-enter {
      opacity: 0;
      transform: translate3d(100%, 0 ,0);
    }
    .Router {     
      transition: all .322s ease;
      position:absolute;
      left:0;
      top:0;
      width:100%;
      height:100%;
      /* will-change: transform;       */
      /* perspective: 1000; */
    }
  .van-tabs__line{background-color:rgba(255, 255, 255, 0.2)!important;width: 60.5px!important;height: 50%!important;bottom: 22px!important;}
  .van-tabs__wrap--scrollable .van-tabs__nav{background-color:#0076bf!important;border: 1px solid #0076bf!important;}
  .van-tab{color:#fff!important;} 

.pageTop{width:100%;height:30px;background-color:#ededed;display: flex;flex-flow:  row nowrap;  justify-content: space-between; padding:5px 0;}
.pageTop>.left{margin-left:10px}
.pageTop>.left>.title{font-size: 14px;line-height: 28px;font-weight: bold;}
.pageTop>.right{margin-right:10px}


.van-tabs__nav--card{margin:5px 5px 0!important;border:1px solid #0076bf!important;background-color:#0076bf!important;}
.van-tabs__nav--card .van-tab.van-tab--active{background-color:rgba(255, 255, 255, 0.2)!important}
.van-tabs__nav--card .van-tab{border-right:1px solid #0076bf!important}
.van-tabs--card>.van-tabs__wrap{height:45px!important}
.cx_checkbox{display: inline-block!important;padding: 5px; }
.vxe-table .vxe-header--column.col--ellipsis{vertical-align: middle!important;}
.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{border-width:0!important}

.amap-marker-label{
    border: 0;
    background-color: transparent;
    position: absolute;
    z-index: 2;
    white-space: nowrap;
    cursor: default;
    padding: 3px;
    font-size: 12px;
    line-height: 14px;
}
.info{
    position: relative;
    top: 0;
    right: 0;
    min-width: 0;
    padding: 6px;
    margin-bottom: 1rem;
    border-radius: .25rem;   
    background-color: white;
    width: 100px;    
    border-width: 0;    
    box-shadow: 0 2px 6px 0 rgba(114, 124, 245, .5);
}
.van-swipe__indicator{background-color:#000!important}
.van-swipe__indicator--active{background-color:#0076bf!important}

.grow-box table,.grow-box td,.grow-box th{border:1px solid #CCC;}
.grow-box th,.grow-box td{padding: 4px;}
.gridBox .van-grid-item__content{background:rgba(0, 0, 0, 0)!important}
</style>
